/**
 * Admin 層級單一 tenant 資料源
 * 由 AdminLayout 呼叫一次 useTenant，子元件（TenantSettings、AdminRagChatbot 等）從 Context 讀取，減少重複 GET /api/tenants/me。
 */

import { createContext, useContext, type ReactNode } from 'react';
import type { TenantsGetMe200Data } from '@pos/api-sdk';

export interface AdminTenantContextValue {
  tenant: TenantsGetMe200Data | undefined;
  isLoading: boolean;
  error: unknown;
  mutate: () => void;
  /** 實際使用的租戶 ID（asTenantId 或 localStorage tenant_id） */
  effectiveTenantId: string | null;
}

const AdminTenantContext = createContext<AdminTenantContextValue | null>(null);

export function AdminTenantProvider({
  value,
  children,
}: {
  value: AdminTenantContextValue;
  children: ReactNode;
}) {
  return (
    <AdminTenantContext.Provider value={value}>
      {children}
    </AdminTenantContext.Provider>
  );
}

/**
 * 在 Admin 內取得 tenant 資料（來自 Context）。
 * 若不在 Provider 內則回傳 null，呼叫端應 fallback 至 useTenant。
 */
export function useAdminTenant(): AdminTenantContextValue | null {
  return useContext(AdminTenantContext);
}
